import axios from 'axios';
import { Product, StoreData, OrderPayload, OrderResponse, Category } from '../types';
import { API_BASE_URL } from '../constants';

// Axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getStoreInfo = async (tenantId: string): Promise<StoreData> => {
  try {
    const res = await api.get(`/store/${tenantId}`);
    // Handle both direct object or wrapped in data
    return res.data.data ? res.data.data : res.data;
  } catch (error) {
    console.error("Error fetching store:", error);
    throw new Error('Failed to load store');
  }
};

export const getCategories = async (tenantId: string): Promise<Category[]> => {
  try {
    const res = await api.get(`/categories/${tenantId}`);
    // Backend retorna o array direto das categorias
    return Array.isArray(res.data) ? res.data : [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

// ... (mantenha o código anterior igual)

export const getProducts = async (tenantId: string): Promise<Product[]> => {
  try {
    // CORREÇÃO: Ajuste para a rota correta do Backend (/store/ID/products)
    const res = await api.get(`/store/${tenantId}/products`);

    // CORREÇÃO: O Backend retorna o array direto (res.data), não res.data.data
    return Array.isArray(res.data) ? res.data : [];
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

// ... (mantenha o código posterior igual)

export const placeOrder = async (order: OrderPayload): Promise<OrderResponse> => {
  try {
    // The endpoint might be different or same base. Assuming based on prompt pattern.
    // If the base URL is the webhook/api, we append /order/tenant_id
    // Note: If the N8N flow handles POST on the same root, we might need adjustment.
    // Following prompt instruction for structure:
    const res = await axios.post(`https://2n8n.viniciusomatos.com/webhook/c30db833-425b-4b0a-90a6-ce70addae783/order/${order.tenant_id}`, order);
    return res.data;
  } catch (error) {
    console.error("Order Error:", error);
    throw error;
  }
};

// Adicione isso no final do arquivo
export const updateStoreSettings = async (formData: FormData) => {
  try {
    // AQUI ESTÁ O SEGREDO: 'transformRequest'
    // Isso impede que o Axios converta o FormData em JSON (que era o erro 'logo: {}')
    // E ao retornar 'data' puro, o navegador adiciona automaticamente o boundary correto.
    const res = await api.put('/settings', formData, {
      transformRequest: [(data) => data]
    });
    return res.data;
  } catch (error) {
    console.error("Erro ao atualizar configurações:", error);
    throw error;
  }
};
